<template>
  <answer-template
    :answer-type="'audio'"
    :input-data="inputData"
    :index="index"
    :wrapper-class="'audio-answer'"
    @deleted="$emit('deleted')"
  >
    <template v-slot:label>Send audio</template>
    <template v-slot:content>
      <div class="audio-box" @mouseover="onHover=true" @mouseleave="onHover=false">
        <div
          class="center-btn"
          :class="{'has-audio': !noUrl}"
          v-show="onHover || noUrl"
          @click="setMediaUrl">
              <span class="icon">
                <font-awesome-icon icon="pen"></font-awesome-icon>
              </span>
        </div>
        <div class="audio-wrapper">
          <audio style="height: 55px;" ref="audio_ref" controls
                 v-on:loadedmetadata="loadedMetaData"
                 v-html="audioSrc">
          </audio>
        </div>
      </div>
    </template>
  </answer-template>
</template>
<script>
import AnswerTemplate from './AnswerTemplate.vue';

export default {
  name: 'AudioAnswer',
  components: {
    AnswerTemplate,
  },
  props: {
    inputData: {
      type: Object,
      default() {
        return {
          type: 'send_audio',
          url: '',
          duration: 0,
        };
      },
    },
    index: {
      type: Number,
    },
  },
  data() {
    return {
      onHover: true,
      tempInput: '',
      validCheck: false,
    };
  },
  methods: {
    loadedMetaData(ev) {
      try {
        const { duration } = ev.target;
        // console.log('DURATION', duration);
        this.inputData.duration = duration * 1000;
        this.inputData.playable = true;
      } catch (e) {
        // console.log('Duration error...', e);
      }
    },
    setMediaUrl() {
      if (this.inputData.url) {
        this.tempInput = this.inputData.url;
      } else {
        this.tempInput = '';
      }
      this.$buefy.dialog.prompt({
        title: 'Audio message',
        message: 'Please enter audio url. (Must be https://)',
        inputAttrs: {
          placeholder: 'e.g. https://sample-audios.com/test.mp3',
          pattern: '^(https:\\/\\/)[a-z0-9]+([\\-\\.]{1}[a-z0-9]+)*\\.[a-z]{2,5}(:[0-9]{1,5})?(\\/.*)?$',
          value: this.tempInput,
          title: 'URL must be https.',
        },
        onConfirm: (url) => {
          this.inputData.url = url;
          this.inputData.playable = false;
          this.$nextTick(() => {
            const audioObj = this.$refs.audio_ref;
            if (audioObj) {
              audioObj.load();
            }
          });
          this.toggleDirty();
        },
      });
    },
    toggleDirty() {
      this.$emit('dirty');
    },
  },
  computed: {
    noUrl() {
      return !this.inputData.url;
    },
    audioSrc() {
      if (this.inputData.url) {
        return `<source src="${this.inputData.url}">`;
      }
      return '';
    },
  },
};
</script>
<style lang="scss" scoped>
  .audio-answer {
    .audio-box {
      background-color: #f3f5f5;
      border: 1px solid #eee;
      min-height: 55px;
      position: relative;
      .center-btn {
        z-index: 10;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -15px;
        margin-left: -20px;
        cursor: pointer;
        color: #797979;
        background-color: rgba(238, 238, 238, 0.8);
        border-radius: 50px;
        padding: 4px 0 0 0;
        line-height: 20px;
        width: 48px;
        text-align: center;
        &:hover {
          color: #333;
        }
        &.has-audio {
          display: block !important;
          top: 50%;
          left: 100%;
          margin-top: -15px;
          margin-left: -50px;
        }
      }
      .audio-wrapper {
        height: 55px;
        width: 100%;
      }
    }
  }
</style>
